import React from 'react';
import { SVGProps } from './types';

export const CopyIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M6.667 17.507V6.673L17.5 6.68v10.827H6.666z"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M15 6.673V2.515L2.5 2.507v12.5h4.167"
      />
    </svg>
  );
};
